module.exports = __webpack_public_path__ + "static/media/23.39a65a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/23.png
// module id = 1397
// module chunks = 0